(function (root) {
  'use strict';
  function enabled(config) { return config?.enabled === true && Array.isArray(config.packs); }
  function forQuantity(config, quantity) { return enabled(config) ? config.packs.find(p => p.quantity === Number(quantity)) || null : null; }
  function forItem(config, item) { return enabled(config) ? config.packs.find(p => String(p.variant_id) === String(item.variant_id || item.id)) || null : null; }
  function containsProduct(config, item, handle) { return enabled(config) && config.source_handle === handle && !!forItem(config, item); }
  function bestComposition(config, quantity) {
    if (!enabled(config) || !Number.isInteger(quantity) || quantity < 1 || quantity > 1000) return null;
    const choices = [{ quantity: 1, variant_id: config.source_variant_id, price_cents: config.single_price_cents }, ...config.packs];
    const best = Array(quantity + 1).fill(null); best[0] = { cost: 0, counts: {} };
    for (let n = 1; n <= quantity; n++) {
      for (const choice of choices) {
        if (choice.quantity > n || !best[n - choice.quantity]) continue;
        const previous = best[n - choice.quantity], cost = previous.cost + choice.price_cents;
        if (!best[n] || cost < best[n].cost) best[n] = { cost, counts: { ...previous.counts, [choice.variant_id]: (previous.counts[choice.variant_id] || 0) + 1 } };
      }
    }
    return best[quantity];
  }
  function migrationPlan(cart, config) {
    if (!enabled(config) || !Array.isArray(cart?.items)) return null;
    const updates = {}, additions = {}; let changed = false;
    for (const item of cart.items) {
      if (String(item.variant_id || item.id) !== String(config.source_variant_id) || item.quantity < 2) continue;
      if (Object.keys(item.properties || {}).some(k => k !== '_offer')) throw new Error('Please review the custom options on your feeder before checkout.');
      const plan = bestComposition(config, item.quantity);
      if (!plan) throw new Error('Please contact us to arrange this feeder quantity.');
      updates[item.key] = 0; changed = true;
      for (const [id, count] of Object.entries(plan.counts)) additions[id] = (additions[id] || 0) + count;
    }
    if (!changed) return null;
    for (const [id, count] of Object.entries(additions)) {
      const existing = cart.items.filter(i => String(i.variant_id || i.id) === id && updates[i.key] !== 0);
      if (existing.some(i => Object.keys(i.properties || {}).some(k => k !== '_offer'))) throw new Error('Please review the custom options on your feeder packs before checkout.');
      const total = count + existing.reduce((sum, item) => sum + item.quantity, 0);
      if (existing.length) {
        updates[existing[0].key] = total;
        for (const item of existing.slice(1)) updates[item.key] = 0;
      } else updates[id] = total;
    }
    return { updates };
  }
  const api = { enabled, forQuantity, forItem, containsProduct, bestComposition, migrationPlan };
  root.LMPackOffers = api;
  if (typeof module !== 'undefined') module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
